export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8">有片源推荐、问题反馈或合作想法？欢迎随时联系</p>
        <div className="bg-background-100/70 rounded-lg p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿邮箱</div>
                <div className="text-sm font-medium text-foreground-800">contact@aiyaaiya.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-chat-3-line text-accent-700 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">片源推荐</div>
                <div className="text-sm font-medium text-foreground-800">submit@aiyaaiya.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-bug-line text-secondary-700 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">问题反馈</div>
                <div className="text-sm font-medium text-foreground-800">feedback@aiyaaiya.com</div>
              </div>
            </div>
          </div>
          <p className="mt-6 text-xs text-foreground-500">我们的团队通常在工作日 24 小时内回复，期待你的来信！</p>
        </div>
      </div>
    </section>
  );
}